// LEVOA: open the cart drawer automatically after add-to-cart
document.addEventListener('cart:update', function (event) {
  try {
    if (document.body.classList.contains('template-cart')) { return; }
    var d = event && event.detail ? event.detail : {};
    var src = (d.data && d.data.source) || d.source || '';
    if (src && String(src).indexOf('cart-items') !== -1) { return; }
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== "function") { return; }
    var dlg = drawer.querySelector('dialog');
    if (dlg && dlg.open) { return; }
    drawer.open();
  } catch (e) {}
});